// Where a first-time student lands after their first read (/welcome's dive and
// the first-read bar). One definition, imported by both hand-offs and read by
// the Launchpad, so the two can never point at different places.
//
// Founder decision, 2026-10-12 (#4037): the hand-off lands on the Launchpad
// CARD for the school, where they stand (the band and the labelled rate), not
// on the Strategy page, which since pick E (#4013) holds the plan only and no
// band. Strategy stays one tap away through the card's own "Strategy" button.
export const ONBOARDING_LANDING_TARGET = 'card';

export const onboardingLandingPath = (universityId) =>
    `/launchpad?school=${encodeURIComponent(universityId)}&onboard=1`;

// The card's onboarding line. Names only what the card prints (the band and
// the admit rate behind it) and the button that opens the rest.
export const onboardingCardLine = (name) =>
    `This card is where you stand at ${name}: your band, and the admit rate behind it. Tap Strategy on the card for your essays, aid and application plan.`;

// The full-screen first-run journeys: /welcome (#560) and the profile-first
// /start (#4702). Nothing floats over them (Astra's auto-open, the install
// ask, the getting-started bar): on a phone the Astra panel is full-viewport
// and covered /welcome's first screen before paint (#1897), and it covered
// /start's form the same way in the #4702 mock round.
export const ONBOARDING_PATHS = ['/welcome', '/start'];
export const isOnboardingPath = (pathname) => ONBOARDING_PATHS.includes(pathname);

// Pages a guest reads through a share link (/review/<grant>): the reader may
// be signed in to an account of their own, and that account's plan lines
// never belong on the page they were sent (#4704, the parent read).
export const isGuestPath = (pathname) => typeof pathname === 'string' && pathname.startsWith('/review/');
